import { createAction, props } from '@ngrx/store';
import { CurrencyData, Provider } from '../common/models';
import { ApiToken, UserDetails } from '../pages/cabinet/pages/profile/models';

export enum ActionTypes {
  LOAD_CURRENCIES = '[Common] Load currencies',
  LOAD_CRYPTO_CURRENCIES = '[Common] Load crypto currencies',

  LOAD_USER_DETAILS = '[Common] Load user details',
  LOAD_API_TOKEN = '[Common] Load api token',
  LOAD_PROVIDERS = '[Common] Load providers',
  SET_ERROR = '[Common] Failure',
  SET_LOADING = '[Common] Set loading',

  SET_PROVIDERS = '[Common] Set providers',

  SET_USER_DETAILS = '[Common] Set user details',
  SET_API_TOKEN = '[Common] Set api token',
  UPDATE_USER = '[Common] Update user',
  SET_CURRENCY_DATA = '[Common] Set currency data',
}

const loadCurrencies = createAction(ActionTypes.LOAD_CURRENCIES);
const loadProviders = createAction(ActionTypes.LOAD_PROVIDERS);
const loadApiToken = createAction(ActionTypes.LOAD_API_TOKEN);

const updateUser = createAction(ActionTypes.UPDATE_USER, props<{ data: Partial<UserDetails> }>());

const setCurrencyData = createAction(ActionTypes.SET_CURRENCY_DATA, props<{ currencyData: Array<CurrencyData> }>());

const setProviders = createAction(ActionTypes.SET_PROVIDERS, props<{ providers: Array<Provider> }>());

const setUserDetails = createAction(ActionTypes.SET_USER_DETAILS, props<{ userDetails: UserDetails }>());

const setApiToken = createAction(ActionTypes.SET_API_TOKEN, props<{ apiToken: ApiToken[] }>());

const loadUserDetails = createAction(ActionTypes.LOAD_USER_DETAILS);

const setError = createAction(ActionTypes.SET_ERROR, props<{ error: string }>());

const setLoading = createAction(ActionTypes.SET_LOADING, props<{ loading: boolean }>());

export const Actions = {
  loadApiToken,
  loadCurrencies,
  loadProviders,
  setCurrencyData,
  setProviders,
  loadUserDetails,
  setApiToken,
  setUserDetails,
  updateUser,
  setError,
  setLoading,
};
